export const API_URL = process.env.NEXT_PUBLIC_WEB_URL
export const IMG_URL=process.env.NEXT_PUBLIC_ALT_WEB_URL
export const ENCRYPT_KEY=process.env.NEXT_PUBLIC_LARAVEL_KEY

